export const packageTypes = ['EACH', 'CASE', 'PALLET'];

export type PackageType = typeof packageTypes[number];
